import React from 'react'
import cx from 'classnames'
import styles from './Statement.module.scss'
import NoContent from 'views/components/molecules/NoContent/NoContent'
import { isEmpty } from 'ramda'

interface StatementItem {
  timestamp?: string
  date: string
  description?: string
  debit?: string
  credit?: string
  balance?: string
  /** A payout reversal (rejected/returned payment flowing back to the lease); styled apart from a payment. */
  reversal?: boolean
}

interface StatementData {
  items: StatementItem[]
  openingBalance?: string
  closingBalance?: string
  startDate?: string
  endDate?: string
}

interface StatementProps {
  context: {
    statement: StatementData
  }
}

/**
 * The opening balance, column headers and closing balance are flex siblings *outside* the scroller,
 * so they stay pinned by layout as the transactions scroll between them.
 */
const Statement = ({
  context: {
    statement: { items, openingBalance, closingBalance, startDate, endDate },
  },
}: StatementProps) => {
  return (
    <div className={styles.table}>
      <div className={cx([styles.row, styles['row--head']])}>
        <div>Date</div>
        <div>Details</div>
        <div>Debit</div>
        <div>Credit</div>
        <div>Balance</div>
      </div>

      <div className={cx([styles.row, styles['row--balance']])}>
        <div>{startDate}</div>
        <div>Opening balance</div>
        <div>{openingBalance}</div>
      </div>

      <div className={styles.scroller}>
        {!isEmpty(items) ? (
          items.map((item, i) => (
            <div className={cx(styles.row, { [styles['row--reversal']]: item.reversal })} key={i}>
              <div>{item.date.split(' ')[0]}</div>
              <div>{item.description}</div>
              <div className={styles.debit}>{item.debit ?? ''}</div>
              <div className={styles.credit}>{item.credit ?? ''}</div>
              <div>{item.balance ?? ''}</div>
            </div>
          ))
        ) : (
          <div className={styles['no-content']}>
            <NoContent heading="No transactions in this period." />
          </div>
        )}
      </div>

      <div className={cx([styles.row, styles['row--balance'], styles['row--closing']])}>
        <div>{endDate}</div>
        <div>Closing balance</div>
        <div>{closingBalance}</div>
      </div>
    </div>
  )
}

export default Statement
